import * as ACTIONS from "../actions/types"

// This reducer handles flags for the journey component to go to the next or previous page
// The journey component then consumes these, turning off the flag whilst telling the
// router to change page
// As it doing is side effects, there must be a better way to do this...

const initialState = {
  gotoNextPage: false,
  gotoPrevPage: false,
  gotoFirstPage: false,
  submitResults: false,
  jumpPage: false,
  resetJourney: false
}

// This just deals with the three flag actions
export default (state = initialState, { type }) => {
  switch (type) {
    case ACTIONS.FLAG_NEXT_PAGE:
      return { ...state, gotoNextPage: true }

    case ACTIONS.FLAG_JUMP_PAGE:
      return { ...state, jumpPage: true }

    case ACTIONS.FLAG_PREV_PAGE:
      return { ...state, gotoPrevPage: true }

    case ACTIONS.FLAG_GOTO_FIRST_PAGE:
      return { ...state, gotoFirstPage: true }

    case ACTIONS.FLAG_SUBMIT:
      return { ...state, submitResults: true }

    case ACTIONS.FLAG_RESET_JOURNEY:
      return { ...state, resetJourney: true }

    case ACTIONS.UNSET_PAGE_FLAGS:
      return initialState

    default:
      return state
  }
}
